// import Storage from '../../services/api/store';
// import CONSTANT from '../../constant';

import {
    default as actions,
    LIST, ADD, REMOVE
} from './action';

const defaultState = {
    // 扩展列表
    exts: [],
    // 设备角色列表
    devices: [],
    // 扩展标签
    tags: [],
    // 已安装过的列表
    installed: [],
    // installed: eval(Storage.get(CONSTANT.INSTALLED_EXT)) || [],
    // 在线设备扩展
    list: []
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case LIST:
        case ADD:
        case REMOVE:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
};

export default {
    reducer,
    actions
};